import { render, staticRenderFns } from "./BlindTransfer.vue?vue&type=template&id=62511cac&scoped=true&"
import script from "./BlindTransfer.vue?vue&type=script&lang=js&"
export * from "./BlindTransfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62511cac",
  null
  
)

export default component.exports